import '@fortawesome/fontawesome-pro/css/all.min.css';
import SbsFaIcon from './SbsFaIcon.vue';

/**
 * @typedef { import('vue/types/plugin').PluginObject } PluginObject
 * @type { PluginObject }
 */
const SbsFaIconsPlugin = {
    install(VueInstance) {
        VueInstance.component('SbsFaIcon', SbsFaIcon);
    },
};

export { SbsFaIcon };
export default SbsFaIconsPlugin;
